module.exports = __webpack_public_path__ + "static/img/service_cont_04_zh.f6ea2e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_cont_04_zh.png
// module id = zUcS
// module chunks = 34